/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Remove_MemberInputs */

const en_action_remove_member = /** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Member`)
};

const es_action_remove_member = /** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar Miembro`)
};

const fr_action_remove_member = /** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer le membre`)
};

const de_action_remove_member = /** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglied entfernen`)
};

const id_action_remove_member = /** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hapus Anggota`)
};

/** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */
const ja_action_remove_member = en_action_remove_member;

/** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */
const zh_action_remove_member = en_action_remove_member;

/** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */
const ar_action_remove_member = en_action_remove_member;

/** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */
const it_action_remove_member = en_action_remove_member;

/** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */
const ru_action_remove_member = en_action_remove_member;

/** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */
const pt_action_remove_member = en_action_remove_member;

/** @type {(inputs: Action_Remove_MemberInputs) => LocalizedString} */
const ko_action_remove_member = en_action_remove_member;

/**
* | output |
* | --- |
* | "Remove Member" |
*
* @param {Action_Remove_MemberInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_remove_member = /** @type {((inputs?: Action_Remove_MemberInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Remove_MemberInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_remove_member(inputs)
	if (locale === "es") return es_action_remove_member(inputs)
	if (locale === "fr") return fr_action_remove_member(inputs)
	if (locale === "de") return de_action_remove_member(inputs)
	if (locale === "ja") return ja_action_remove_member(inputs)
	if (locale === "zh") return zh_action_remove_member(inputs)
	if (locale === "ar") return ar_action_remove_member(inputs)
	if (locale === "id") return id_action_remove_member(inputs)
	if (locale === "it") return it_action_remove_member(inputs)
	if (locale === "ru") return ru_action_remove_member(inputs)
	if (locale === "pt") return pt_action_remove_member(inputs)
	return ko_action_remove_member(inputs)
});